// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".genetic-type-tabs-module__tabs__GzxTj{display:flex;margin:1.5rem 0 0 0}.genetic-type-tabs-module__tab__1XvlZ{text-align:center;padding:0.75rem 0;border:1px solid #0b2569;cursor:pointer}.genetic-type-tabs-module__tab__1XvlZ:first-child{border-top-right-radius:3px}.genetic-type-tabs-module__tab__1XvlZ:last-child{border-top-left-radius:3px}.genetic-type-tabs-module__selectedTab__2avN9{padding-top:0.5rem;border-width:3px 1px 0 1px}.genetic-type-tabs-module__unselectedTab__z4yVX{background-color:#f2f4f8;border-width:0 0 1px 0}\n", ""]);
// Exports
exports.locals = {
	"tabs": "genetic-type-tabs-module__tabs__GzxTj",
	"tab": "genetic-type-tabs-module__tab__1XvlZ",
	"selectedTab": "genetic-type-tabs-module__selectedTab__2avN9",
	"unselectedTab": "genetic-type-tabs-module__unselectedTab__z4yVX"
};
module.exports = exports;
